import React from 'react';
import { ETollSection } from './sections/ETollSection';
import { FormikErrors } from 'formik';
import { DeviceCreateAdvancedFormValues } from './types';
import { TDeviceFormValues } from '../types';

type Props = {
    errors?: FormikErrors<DeviceCreateAdvancedFormValues>;
    values: TDeviceFormValues;
};

export const AdvancedTab = ({ errors, values }: Props) => {
    return <ETollSection values={values} errors={errors} />;
};
